import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { Col } from 'blocks/CommonLayout';
import Card from 'components/Card';
import { getHour, getMinute, getTime } from 'helper/date';
import { FareFlightInterface } from '../../awardTicket.interface';
import * as S from './bookFilightitem.styles';

interface Props {
  fareFligt: FareFlightInterface;
}

const BookFlightItem: React.FC<Props> = ({ fareFligt: { baseFare, segment, totalFare } }) => {
  const renderCabinBox = () => (
    <S.BookFilghtCabinBox as={Col} align="center">
      <S.BookFilghtCabinName>{segment.RBD} from</S.BookFilghtCabinName>
      <S.BookFilghtMiles>
        17,500 <S.BookFilghtMilesSpan>Miles</S.BookFilghtMilesSpan>
      </S.BookFilghtMiles>
      <S.BookFilghtDesc>Tortal price for all passengers</S.BookFilghtDesc>
    </S.BookFilghtCabinBox>
  );

  return (
    <S.BookFilght>
      <S.BookFilghtCard as={Card}>
        <S.BookFilghtDetails>
          <S.BookFilghtDetailsCol as={Col} align="flex-start">
            <S.BookFilghtDetailsTime>{getTime(segment.departureDateTime)} DXB</S.BookFilghtDetailsTime>
            <S.BookFilghtDetailsCity>{segment.departure}</S.BookFilghtDetailsCity>
            <S.BookFilghtDetailsPlane>Flight No: {segment.flightNumber}</S.BookFilghtDetailsPlane>
            {/* <div className="plane">QR 1019 Airbus A350-1000</div> */}
            <S.BookFilghtDetailsCompany>Operated by: Iran Air</S.BookFilghtDetailsCompany>
          </S.BookFilghtDetailsCol>
          <S.BookFilghtDetailsHourInfo as={Col} align="center">
            <S.BookFilghtDetailsSvg as={AccessTimeIcon} />
            <S.BookFilghtDetailsHour>
              {getHour(segment.duration)}h {getMinute(segment.duration)}m
            </S.BookFilghtDetailsHour>
            <S.BookFilght>{segment.stopQuantity} stop(s)</S.BookFilght>
          </S.BookFilghtDetailsHourInfo>
          <Col className="col" align="flex-end">
            <S.BookFilghtDetailsTime>{getTime(segment.arrivalDateTime)} DXB</S.BookFilghtDetailsTime>
            <S.BookFilghtDetailsCity>{segment.destination}</S.BookFilghtDetailsCity>
            <S.BookFilghtDetailsPlane>Flight No: {segment.flightNumber}</S.BookFilghtDetailsPlane>
            {/* <div className="plane">QR 1019 Airbus A350-1000</div> */}
            <S.BookFilghtDetailsCompany>Operated by: Iran Air</S.BookFilghtDetailsCompany>
          </Col>
        </S.BookFilghtDetails>
        <S.BookFilghtCabinClass>{renderCabinBox()}</S.BookFilghtCabinClass>
      </S.BookFilghtCard>
    </S.BookFilght>
  );
};

export default BookFlightItem;
